import {
  PackageSelectionContainer,
  JobNimbusLogo,
  HeaderContainer,
  PageTitle,
  MasterExpandButton,
  Bubble,
  BubbleText,
  SectionWrapper,
  RowContainer,
  RowTitle,
  RowTitleWithToggle,
  AssistAIHeaderToggle,
  ToggleSwitch,
  ToggleSlider,
  ToggleInput,
  BaseCrmCard,
  CardCost,
  UserCardCost,
  TitleContainer,
  BaseCrmCardHeader,
  ExpandButton,
  BaseCrmCardSubHeader,
  BaseCrmCardFooter,
  PackageDetailsContainer,
  BaseCrmCardPackageDetailsHeader,
  BaseCrmCardPackageDetails,
  EngageCard,
  EngageCardHeader,
  EngageCardSubHeader,
  EngageCardPackageDetails,
  UserTypeSelectionContainer,
  UserTypeCard,
  UserTitleContainer,
  UserTitleTextContainer,
  UserTypeCardHeader,
  UserTypeCardSubHeader,
  UserTypeCounterContainer,
  UserTypeCounter,
  UserTypeRightContainer,
  UserTypeCardButtonContainer,
  UserTypeCardButton,
  AdditionalPackagesContainer,
  AdditionalPackagesTitleContainer,
  AdditionalPackagesCardHeader,
  AdditionalPackagesCard,
} from "./styles";

export const PackageSelection = ({
  crmPackage,
  setCrmPackage,
  engageCard,
  setEngageCard,
  adminCount,
  setAdminCount,
  salesCount,
  setSalesCount,
  fieldCount,
  setFieldCount,
  subcontractorCount,
  setSubcontractorCount,
  showAssistAI,
  setShowAssistAI,
  expandedCrmCards,
  setExpandedCrmCards,
  expandedEngageCards,
  setExpandedEngageCards,
  expandedUserCards,
  setExpandedUserCards,
  additionalPackages,
  selectPackage,
}) => {
  const handleMasterExpandCollapse = () => {
    const allCrmCards = ["growing", "established", "enterprise"];
    const allEngageCards = ["starter", "premium", "enterprise"];
    const allUserCards = ["admin", "sales", "field", "subcontractor"];
    const allExpanded = expandedCrmCards.length === 3 && expandedEngageCards.length === 3 && expandedUserCards.length === 4;

    if (allExpanded) {
      // Collapse all
      setExpandedCrmCards([]);
      setExpandedEngageCards([]);
      setExpandedUserCards([]);
    } else {
      // Expand all
      setExpandedCrmCards(allCrmCards);
      setExpandedEngageCards(allEngageCards);
      setExpandedUserCards(allUserCards);
    }
  };

  const toggleCrmCard = (cardName) => {
    if (expandedCrmCards.includes(cardName)) {
      setExpandedCrmCards(expandedCrmCards.filter(card => card !== cardName));
    } else {
      setExpandedCrmCards([...expandedCrmCards, cardName]);
    }
  };

  const toggleEngageCard = (cardName) => {
    if (expandedEngageCards.includes(cardName)) {
      setExpandedEngageCards(expandedEngageCards.filter(card => card !== cardName));
    } else {
      setExpandedEngageCards([...expandedEngageCards, cardName]);
    }
  };

  const toggleUserCard = (cardName) => {
    if (expandedUserCards.includes(cardName)) {
      setExpandedUserCards(expandedUserCards.filter(card => card !== cardName));
    } else {
      setExpandedUserCards([...expandedUserCards, cardName]);
    }
  };

  return (
    <PackageSelectionContainer>
      <JobNimbusLogo src={require("../../Assets/JNLogo.png")} />
      <HeaderContainer>
        <PageTitle>Pricing Calculator</PageTitle>
        <div style={{
          position: 'absolute',
          right: 0,
          top: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          alignItems: 'flex-end',
          zIndex: 10
        }}>
          <MasterExpandButton onClick={handleMasterExpandCollapse}>
            {expandedCrmCards.length > 0 || expandedEngageCards.length > 0 || expandedUserCards.length > 0 ? "Collapse All" : "Expand All"}
          </MasterExpandButton>
          {!showAssistAI && (
            <RowTitleWithToggle className="assistai-toggle-desktop" style={{ marginBottom: 0 }}>
              <RowTitle style={{ marginBottom: 0, fontSize: '0.875rem' }}>AssistAI</RowTitle>
              <ToggleSwitch>
                <ToggleInput
                  type="checkbox"
                  checked={showAssistAI}
                  onChange={(e) => setShowAssistAI(e.target.checked)}
                />
                <ToggleSlider />
              </ToggleSwitch>
            </RowTitleWithToggle>
          )}
        </div>
      </HeaderContainer>
      <SectionWrapper>
        <RowTitle>CRM Package</RowTitle>
        <RowContainer>
          <BaseCrmCard
          onClick={() => {
            if (crmPackage === "growing") {
              setCrmPackage(null);
            } else {
              setCrmPackage("growing");
            }
          }}
          selected={crmPackage === "growing"}
          expanded={expandedCrmCards.includes("growing")}
        >
          <Bubble selected={crmPackage === "growing"} inCollapsedCard={!expandedCrmCards.includes("growing")}>
            <BubbleText>Recommended</BubbleText>
          </Bubble>
          <TitleContainer expanded={expandedCrmCards.includes("growing")}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
              <BaseCrmCardHeader expanded={expandedCrmCards.includes("growing")}>Growing</BaseCrmCardHeader>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                <CardCost inCollapsedCard={!expandedCrmCards.includes("growing")}>$225/month</CardCost>
                <ExpandButton onClick={(e) => {
                  e.stopPropagation();
                  toggleCrmCard("growing");
                }}>
                  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {expandedCrmCards.includes("growing") ? (
                      <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    ) : (
                      <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    )}
                  </svg>
                </ExpandButton>
              </div>
            </div>
            {expandedCrmCards.includes("growing") && (
              <BaseCrmCardSubHeader>
                Single-location Business
              </BaseCrmCardSubHeader>
            )}
          </TitleContainer>
          {expandedCrmCards.includes("growing") && (
            <>
              <PackageDetailsContainer>
                <BaseCrmCardPackageDetailsHeader>
                  Limited Features
                </BaseCrmCardPackageDetailsHeader>
                <BaseCrmCardPackageDetails>
                  Up to 5 integrations
                </BaseCrmCardPackageDetails>
              </PackageDetailsContainer>
            </>
          )}
        </BaseCrmCard>
        <BaseCrmCard
          onClick={() => {
            if (crmPackage === "established") {
              setCrmPackage(null);
            } else {
              setCrmPackage("established");
            }
          }}
          selected={crmPackage === "established"}
          expanded={expandedCrmCards.includes("established")}
        >
          <Bubble selected={crmPackage === "established"} inCollapsedCard={!expandedCrmCards.includes("established")}>
            <BubbleText>Recommended</BubbleText>
          </Bubble>
          <TitleContainer expanded={expandedCrmCards.includes("established")}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
              <BaseCrmCardHeader expanded={expandedCrmCards.includes("established")}>Established</BaseCrmCardHeader>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                <CardCost inCollapsedCard={!expandedCrmCards.includes("established")}>$550/month</CardCost>
                <ExpandButton onClick={(e) => {
                  e.stopPropagation();
                  toggleCrmCard("established");
                }}>
                  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {expandedCrmCards.includes("established") ? (
                      <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    ) : (
                      <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    )}
                  </svg>
                </ExpandButton>
              </div>
            </div>
            {expandedCrmCards.includes("established") && (
              <BaseCrmCardSubHeader>
                Run Multi-locations or Businesses
              </BaseCrmCardSubHeader>
            )}
          </TitleContainer>
          {expandedCrmCards.includes("established") && (
            <>
              <PackageDetailsContainer>
                <BaseCrmCardPackageDetails>
                  Unlimited integrations
                </BaseCrmCardPackageDetails>
                <BaseCrmCardPackageDetails>
                  Access to Open API Documentation
                </BaseCrmCardPackageDetails>
              </PackageDetailsContainer>
            </>
          )}
        </BaseCrmCard>
        </RowContainer>
      </SectionWrapper>
      <SectionWrapper>
        <RowTitle>Texting Package</RowTitle>
        <RowContainer>
          <EngageCard
          onClick={() => {
            if (engageCard === "starter") {
              setEngageCard(null);
            } else {
              setEngageCard("starter");
            }
          }}
          selected={engageCard === "starter"}
          expanded={expandedEngageCards.includes("starter")}
        >
          <Bubble selected={engageCard === "starter"} inCollapsedCard={!expandedEngageCards.includes("starter")}>
            <BubbleText>Recommended</BubbleText>
          </Bubble>
          <TitleContainer expanded={expandedEngageCards.includes("starter")}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
              <EngageCardHeader expanded={expandedEngageCards.includes("starter")}>Starter</EngageCardHeader>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                <CardCost>$49/month</CardCost>
                <ExpandButton onClick={(e) => {
                  e.stopPropagation();
                  toggleEngageCard("starter");
                }}>
                  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {expandedEngageCards.includes("starter") ? (
                      <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    ) : (
                      <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    )}
                  </svg>
                </ExpandButton>
              </div>
            </div>
            {expandedEngageCards.includes("starter") && (
              <EngageCardSubHeader>Ideal for up to 4 lines</EngageCardSubHeader>
            )}
          </TitleContainer>
          {expandedEngageCards.includes("starter") && (
            <PackageDetailsContainer>
              <EngageCardPackageDetails>
                200 credits included per month
              </EngageCardPackageDetails>
              <EngageCardPackageDetails>
                $0.10/additional credit
              </EngageCardPackageDetails>
            </PackageDetailsContainer>
          )}
        </EngageCard>
        <EngageCard
          onClick={() => {
            if (engageCard === "premium") {
              setEngageCard(null);
            } else {
              setEngageCard("premium");
            }
          }}
          selected={engageCard === "premium"}
          expanded={expandedEngageCards.includes("premium")}
        >
          <Bubble selected={engageCard === "premium"} inCollapsedCard={!expandedEngageCards.includes("premium")}>
            <BubbleText>Recommended</BubbleText>
          </Bubble>
          <TitleContainer expanded={expandedEngageCards.includes("premium")}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
              <EngageCardHeader expanded={expandedEngageCards.includes("premium")}>Premium</EngageCardHeader>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                <CardCost>$99/month</CardCost>
                <ExpandButton onClick={(e) => {
                  e.stopPropagation();
                  toggleEngageCard("premium");
                }}>
                  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {expandedEngageCards.includes("premium") ? (
                      <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    ) : (
                      <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    )}
                  </svg>
                </ExpandButton>
              </div>
            </div>
            {expandedEngageCards.includes("premium") && (
              <EngageCardSubHeader>Ideal for 5-10 lines</EngageCardSubHeader>
            )}
          </TitleContainer>
          {expandedEngageCards.includes("premium") && (
            <PackageDetailsContainer>
              <EngageCardPackageDetails>
                2000 credits included per month
              </EngageCardPackageDetails>
              <EngageCardPackageDetails>
                $0.035/additional credit
              </EngageCardPackageDetails>
            </PackageDetailsContainer>
          )}
        </EngageCard>
        <EngageCard
          onClick={() => {
            if (engageCard === "enterprise") {
              setEngageCard(null);
            } else {
              setEngageCard("enterprise");
            }
          }}
          selected={engageCard === "enterprise"}
          expanded={expandedEngageCards.includes("enterprise")}
        >
          <Bubble selected={engageCard === "enterprise"} inCollapsedCard={!expandedEngageCards.includes("enterprise")}>
            <BubbleText>Recommended</BubbleText>
          </Bubble>
          <TitleContainer expanded={expandedEngageCards.includes("enterprise")}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
              <EngageCardHeader expanded={expandedEngageCards.includes("enterprise")}>Enterprise</EngageCardHeader>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                <CardCost>$249/month</CardCost>
                <ExpandButton onClick={(e) => {
                  e.stopPropagation();
                  toggleEngageCard("enterprise");
                }}>
                  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {expandedEngageCards.includes("enterprise") ? (
                      <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    ) : (
                      <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    )}
                  </svg>
                </ExpandButton>
              </div>
            </div>
            {expandedEngageCards.includes("enterprise") && (
              <EngageCardSubHeader>Ideal for 11+ lines</EngageCardSubHeader>
            )}
          </TitleContainer>
          {expandedEngageCards.includes("enterprise") && (
            <PackageDetailsContainer>
              <EngageCardPackageDetails>
                10,000 credits included per month
              </EngageCardPackageDetails>
              <EngageCardPackageDetails>
                $0.025/additional credit
              </EngageCardPackageDetails>
            </PackageDetailsContainer>
          )}
        </EngageCard>
        </RowContainer>
      </SectionWrapper>
      <SectionWrapper>
        <RowTitle>User Selection</RowTitle>
        <UserTypeSelectionContainer>
          <UserTypeCard selected={adminCount > 0} expanded={expandedUserCards.includes("admin")}>
          <UserTitleContainer>
            <UserTitleTextContainer>
              <UserTypeCardHeader>Admin</UserTypeCardHeader>
              <UserCardCost>$75/month</UserCardCost>
              {expandedUserCards.includes("admin") && (
                <UserTypeCardSubHeader>All Access</UserTypeCardSubHeader>
              )}
            </UserTitleTextContainer>
            <ExpandButton onClick={(e) => {
              e.stopPropagation();
              toggleUserCard("admin");
            }}>
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                {expandedUserCards.includes("admin") ? (
                  <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                ) : (
                  <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                )}
              </svg>
            </ExpandButton>
          </UserTitleContainer>
          <UserTypeRightContainer>
            <UserTypeCounterContainer>
              <UserTypeCounter
                value={adminCount}
                type="number"
                onChange={(e) => setAdminCount(parseInt(e.target.value))}
              />
              <UserTypeCardButtonContainer>
                <UserTypeCardButton
                  onClick={() => setAdminCount(adminCount + 1)}
                >
                  +
                </UserTypeCardButton>
                <UserTypeCardButton
                  onClick={() =>
                    adminCount > 0 && setAdminCount(adminCount - 1)
                  }
                >
                  -
                </UserTypeCardButton>
              </UserTypeCardButtonContainer>
            </UserTypeCounterContainer>
          </UserTypeRightContainer>
        </UserTypeCard>
        <UserTypeCard selected={salesCount > 0} expanded={expandedUserCards.includes("sales")}>
          <UserTitleContainer>
            <UserTitleTextContainer>
              <UserTypeCardHeader>Sales/Office</UserTypeCardHeader>
              <UserCardCost>$55/month</UserCardCost>
              {expandedUserCards.includes("sales") && (
                <UserTypeCardSubHeader>
                  Excludes Subscription<br></br>and Settings Access
                </UserTypeCardSubHeader>
              )}
            </UserTitleTextContainer>
            <ExpandButton onClick={(e) => {
              e.stopPropagation();
              toggleUserCard("sales");
            }}>
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                {expandedUserCards.includes("sales") ? (
                  <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                ) : (
                  <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                )}
              </svg>
            </ExpandButton>
          </UserTitleContainer>
          <UserTypeRightContainer>
            <UserTypeCounterContainer>
              <UserTypeCounter
                value={salesCount}
                type="number"
                onChange={(e) => setSalesCount(parseInt(e.target.value))}
              />
              <UserTypeCardButtonContainer>
                <UserTypeCardButton
                  onClick={() => setSalesCount(salesCount + 1)}
                >
                  +
                </UserTypeCardButton>
                <UserTypeCardButton
                  onClick={() =>
                    salesCount > 0 && setSalesCount(salesCount - 1)
                  }
                >
                  -
                </UserTypeCardButton>
              </UserTypeCardButtonContainer>
            </UserTypeCounterContainer>
          </UserTypeRightContainer>
        </UserTypeCard>
        <UserTypeCard selected={fieldCount > 0} expanded={expandedUserCards.includes("field")}>
          <UserTitleContainer>
            <UserTitleTextContainer>
              <UserTypeCardHeader>Field</UserTypeCardHeader>
              <UserCardCost>$30/month</UserCardCost>
              {expandedUserCards.includes("field") && (
                <UserTypeCardSubHeader>
                  Mobile App Access Only<br></br>No Reporting Access
                </UserTypeCardSubHeader>
              )}
            </UserTitleTextContainer>
            <ExpandButton onClick={(e) => {
              e.stopPropagation();
              toggleUserCard("field");
            }}>
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                {expandedUserCards.includes("field") ? (
                  <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                ) : (
                  <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                )}
              </svg>
            </ExpandButton>
          </UserTitleContainer>
          <UserTypeRightContainer>
            <UserTypeCounterContainer>
              <UserTypeCounter
                value={fieldCount}
                type="number"
                onChange={(e) => setFieldCount(parseInt(e.target.value))}
              />
              <UserTypeCardButtonContainer>
                <UserTypeCardButton
                  onClick={() => setFieldCount(fieldCount + 1)}
                >
                  +
                </UserTypeCardButton>
                <UserTypeCardButton
                  onClick={() =>
                    fieldCount > 0 && setFieldCount(fieldCount - 1)
                  }
                >
                  -
                </UserTypeCardButton>
              </UserTypeCardButtonContainer>
            </UserTypeCounterContainer>
          </UserTypeRightContainer>
        </UserTypeCard>
        <UserTypeCard selected={subcontractorCount > 0} expanded={expandedUserCards.includes("subcontractor")}>
          <UserTitleContainer>
            <UserTitleTextContainer>
              <UserTypeCardHeader>Subcontractor</UserTypeCardHeader>
              <UserCardCost>$20/month</UserCardCost>
              {expandedUserCards.includes("subcontractor") && (
                <UserTypeCardSubHeader>
                  Mobile only: shared jobs,<br></br>photos, and work orders
                </UserTypeCardSubHeader>
              )}
            </UserTitleTextContainer>
            <ExpandButton onClick={(e) => {
              e.stopPropagation();
              toggleUserCard("subcontractor");
            }}>
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                {expandedUserCards.includes("subcontractor") ? (
                  <path d="M12 10L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                ) : (
                  <path d="M12 6L8 10L4 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                )}
              </svg>
            </ExpandButton>
          </UserTitleContainer>
          <UserTypeRightContainer>
            <UserTypeCounterContainer>
              <UserTypeCounter
                value={subcontractorCount}
                type="number"
                onChange={(e) => setSubcontractorCount(parseInt(e.target.value))}
              />
              <UserTypeCardButtonContainer>
                <UserTypeCardButton
                  onClick={() => setSubcontractorCount(subcontractorCount + 1)}
                >
                  +
                </UserTypeCardButton>
                <UserTypeCardButton
                  onClick={() =>
                    subcontractorCount > 0 && setSubcontractorCount(subcontractorCount - 1)
                  }
                >
                  -
                </UserTypeCardButton>
              </UserTypeCardButtonContainer>
            </UserTypeCounterContainer>
          </UserTypeRightContainer>
        </UserTypeCard>
        </UserTypeSelectionContainer>
      </SectionWrapper>
      <div className="assistai-toggle-mobile">
        <SectionWrapper>
          <RowTitleWithToggle style={{ marginBottom: 0, justifyContent: 'center' }}>
            <RowTitle style={{ marginBottom: 0, fontSize: '1rem' }}>AssistAI</RowTitle>
            <ToggleSwitch>
              <ToggleInput
                type="checkbox"
                checked={showAssistAI}
                onChange={(e) => setShowAssistAI(e.target.checked)}
              />
              <ToggleSlider />
            </ToggleSwitch>
          </RowTitleWithToggle>
        </SectionWrapper>
      </div>
    </PackageSelectionContainer>
  );
};

export const AssistAISection = ({ additionalPackages, selectPackage, showAssistAI, setShowAssistAI }) => {
  return (
    <>
      {additionalPackages.length > 0 && (
        <PackageSelectionContainer style={{ paddingTop: 0, paddingBottom: '1rem', marginTop: 0 }}>
          <SectionWrapper style={{ marginBottom: 0, marginTop: 0, paddingTop: 0 }}>
            <div className="assistai-toggle-section-header" style={{ marginTop: 0, paddingTop: 0 }}>
              <AssistAIHeaderToggle>
                <RowTitle style={{ marginBottom: 0, marginTop: 0 }}>AssistAI</RowTitle>
                <ToggleSwitch>
                  <ToggleInput
                    type="checkbox"
                    checked={showAssistAI}
                    onChange={(e) => setShowAssistAI(e.target.checked)}
                  />
                  <ToggleSlider />
                </ToggleSwitch>
              </AssistAIHeaderToggle>
            </div>
            <AdditionalPackagesContainer style={{ marginTop: 0, paddingTop: 0 }}>
              {additionalPackages.map((p) => (
                <AdditionalPackagesCard
              selected={p.isSelected}
              onClick={() => selectPackage(p)}
            >
              <AdditionalPackagesTitleContainer>
                <AdditionalPackagesCardHeader>
                  {p.name}
                </AdditionalPackagesCardHeader>
                <CardCost>${p.cost}/month</CardCost>
              </AdditionalPackagesTitleContainer>
            </AdditionalPackagesCard>
              ))}
            </AdditionalPackagesContainer>
          </SectionWrapper>
        </PackageSelectionContainer>
      )}
    </>
  );
};
